<script lang="ts" setup>
import type { IProps } from './MsFoundationItems.types'
import MsFoundationItem from './MsFoundationItem.vue'

defineProps<IProps>()

</script>

<template>
  <div class="ms-foundation-items">
    <MsFoundationItem
      v-for="(item, index) in items"
      :key="`ms-foundation-item-${index}`"
      :item="item"
    />
  </div>
</template>

<style lang="scss" scoped>
.ms-foundation-items {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 3.2rem;
}

@include atXS {
  .ms-foundation-items {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
</style>
